import { Route } from "react-router-dom"
import React from "react"
import { pagesUrl } from "../core/appConstants"
import { BimModelExtensionPage } from "../pages/tableau-extensions/bim-viewer/BimModelExtensionPage"

export const TableauExtensionsRoutes: React.JSX.Element = (
  <Route path={pagesUrl.EXTENSION_BIM_VIEWER} element={<BimModelExtensionPage />} />
)
